import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import LogoPremium from "../../assets/images/logo.png";
import { NavLink } from "react-router-dom";

function Copyright() {
	return (
		<Typography variant="body2" color="textSecondary">
			{"Copyright © "}
			<Link color="inherit" href="https://material-ui.com/">
				MMS
			</Link>{" "}
			{new Date().getFullYear()}
			{"."}
		</Typography>
	);
}

const useStyles = makeStyles((theme) => ({
	footer: {
		color: "#373435",
		padding: theme.spacing(3, 2),
		backgroundColor:
			theme.palette.type === "light"
				? theme.palette.grey[200]
				: theme.palette.grey[800],
	},
}));

export default function StickyFooter() {
	function scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}

	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CssBaseline />
			<footer className={classes.footer}>
				<div className={"footer-section"}>
					<div className={"footer-left"}>
						<div>
							<ul>
								<li>
									<NavLink
										onClick={() => scrollToTop()}
										to={"#"}
									>
										Home
									</NavLink>
								</li>
								{window.location.href.includes(
									"politica-de-privacidade"
								) ? (
									<li>
										<NavLink
											onClick={() => scrollToTop()}
											to={"#"}
										>
											Política de Privacidade
										</NavLink>
									</li>
								) : (
									<li>
										<NavLink
											to={"politica-de-privacidade"}
										>
											Política de Privacidade
										</NavLink>
									</li>
								)}
								{window.location.href.includes(
									"politica-de-cookies"
								) ? (
									<li>
										<NavLink
											onClick={() => scrollToTop()}
											to={"#"}
										>
											Política de cookies
										</NavLink>
									</li>
								) : (
									<li>
										<NavLink to={"politica-de-cookies"}>
											Política de cookies
										</NavLink>
									</li>
								)}
								{window.location.href.includes(
									"termo-de-uso"
								) ? (
									<li>
										<NavLink
											onClick={() => scrollToTop()}
											to={"#"}
										>
											Termos de uso
										</NavLink>
									</li>
								) : (
									<li>
										<NavLink to={"termo-de-uso"}>
											Termos de uso
										</NavLink>
									</li>
								)}
							</ul>
						</div>
					</div>
					<div className={"footer-center"}>
						<div>
							<a href="mailto:contato@mms.com.vc">
								contato@mms.com.vc
							</a>
						</div>
					</div>
					<div className={"footer-right"}>
						<div>
							<img
								className={"toolbar_img"}
								alt={"Logo-Premium"}
								src={LogoPremium}
							/>
							<Container maxWidth="sm">
								<Copyright />
								<Typography variant="body1"></Typography>
							</Container>
						</div>
					</div>
				</div>
				<div className="footer-cookies">
					<p>
						Nós usamos cookies em nosso site. Os cookies são
						utilizados para melhorar a funcionalidade e o uso do
						nosso site, além de contribuir para nossas análises.
						Para saber mais sobre o que são cookies, nossa política
						e como alterar suas configurações de cookies do seu
						computador,{" "}
						<NavLink to={"politica-de-cookies"}>
							clique aqui
						</NavLink>
						. Ao continuar a usar este site sem alterar suas
						configurações, você concorda com o uso de cookies.
					</p>
				</div>
			</footer>
		</div>
	);
}
